import { useUpgradeSessionSync } from "@/hooks/useUpgradeSessionSync"

/**
 * Renders nothing. Mounted once for every signed-in user, next to the modals but
 * not inside one: the session refresh after an upgrade must not depend on whether
 * a modal happens to render (it returns early for most users most of the time).
 */
export const UpgradeSessionSync: React.FC = () => {
  useUpgradeSessionSync()
  return null
}
